/**
 * Ein Ticket im Text eines anderen nennen: `T-0036`.
 *
 * Dieselbe Regel wie bei den Erwähnungen: Der Text bleibt gewöhnlicher Text.
 * Niemand tippt einen Markdown-Link in einen Kommentar, und dieselbe
 * Beschreibung steht später in einer Mail und in `scripts/tickets.py show`. Die
 * Anzeige erkennt die Nummern und holt sich dazu in **einem** Aufruf, was in den
 * Tooltip gehört.
 *
 * Verlinkt wird nur, was es wirklich gibt. Eine Nummer, zu der kein Ticket
 * gehört, bleibt Text — ein Link ins Leere ist schlechter als keiner.
 */

/** Was der Tooltip zeigt. Kommt vom Server, nicht aus dem Text. */
export interface TicketVerweis {
  id: number;
  number: number;
  label: string;
  title: string;
  status: string;
  severity: string;
  auszug: string;
}

/**
 * Das Präfix des eigenen Systems (`T` oder `L`) plus `#` als Kurzform.
 *
 * Beide Systeme zählen getrennt; eine Nummer des anderen liegt in einer anderen
 * Datenbank und wäre hier ein Link ins Leere. Deshalb kommt das Präfix vom
 * Server (`/testing/status`) und steht nicht fest im Code.
 */
export function verweisMuster(praefix: string): RegExp {
  const sicher = (praefix || 'T').replace(/[^A-Za-z]/g, '') || 'T';
  // `(?<!\w)` davor: Sonst wird aus „CT-36" eine Ticketnummer.
  return new RegExp(`(?<![\\p{L}\\p{N}_])(?:${sicher}-|#)(\\d{1,6})(?![\\p{L}\\p{N}_])`, 'giu');
}

/** Welche Nummern der Text nennt — für den einen Aufruf, der sie auflöst. */
export function nummernImText(text: string, praefix: string, grenze = 25): number[] {
  if (!text) return [];
  const gefunden: number[] = [];
  for (const treffer of text.matchAll(verweisMuster(praefix))) {
    const nummer = Number(treffer[1]);
    if (nummer > 0 && !gefunden.includes(nummer)) gefunden.push(nummer);
    if (gefunden.length >= grenze) break;
  }
  return gefunden;
}
